"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

export default function LogoutButton({ className = "" }: { className?: string }) {
  const router = useRouter();
  const [pending, setPending] = useState(false);

  async function logout() {
    setPending(true);
    try {
      await fetch("/api/auth/logout", { method: "POST" });
    } finally {
      setPending(false);
      router.push("/");
      router.refresh();
    }
  }

  return (
    <button
      type="button"
      onClick={logout}
      disabled={pending}
      className={
        className ||
        "rounded-full border border-emerald-300/30 px-3 py-2 text-sm font-semibold text-emerald-100/80 transition hover:bg-emerald-400/10 hover:text-white disabled:opacity-60"
      }
    >
      {pending ? "…" : "Выйти"}
    </button>
  );
}
